import { binarySelectOptions, useRouter } from '@application/utils';
import { useTranslation } from '@presentation/utils';
import { Form, useFormikContext } from 'formik';
import type { FC } from 'react';
import { TbDog, TbInbox } from 'react-icons/tb';
import { Button } from '../Button';
import { InputCheckboxField } from '../InputCheckboxField';
import { InputField } from '../InputField';
import { InputSelectField } from '../InputSelectField';
import { InputWrapper } from '../InputWrapper';
import dog from './assets/dog.svg';
import sparkles from './assets/sparkles.svg';
import * as Styled from './styled';
import type { BreedInterestFormValues, DogBreedInterestBannerProps } from './types';
import { InputLabel } from '../InputLabel';
import { InputRadioField } from '../InputRadioField';

export * from './types';

export const DOG_BREED_INTEREST_BANNER_ID = 'dog-breed-interest-banner';

export const DogBreedInterestBanner: FC<DogBreedInterestBannerProps> = (props) => {
  const { breedOptions, isSubmitting } = props;
  const { translate } = useTranslation();
  const { routeLocationDescriptor } = useRouter();
  const { errors } = useFormikContext<BreedInterestFormValues>();

  const yesNoOptions = binarySelectOptions(translate);

  return (
    <Styled.Container id={DOG_BREED_INTEREST_BANNER_ID}>
      <Styled.ImageContainer>
        <img src={dog} alt="" />
      </Styled.ImageContainer>

      <Styled.ContentContainer>
        <Styled.Title>{translate('common.sections.breedInterestSubscription.title')}</Styled.Title>
        <Styled.Text>{translate('common.sections.breedInterestSubscription.text')}</Styled.Text>

        <Styled.FormContainer>
          <Form>
            <Styled.FormContent>
              <Styled.ImageLeft>
                <img src={sparkles} alt="" />
              </Styled.ImageLeft>

              <Styled.FormInputs>
                <InputWrapper>
                  <InputSelectField
                    name="dogBreedNames"
                    placeholder={translate('common.inputs.breeds.placeholder')}
                    iconLeft={<TbDog />}
                    options={breedOptions}
                    multiple
                  />
                </InputWrapper>
                <InputWrapper>
                  <InputLabel required>{translate('common.inputs.email.label')}</InputLabel>
                  <InputField
                    name="email"
                    placeholder={translate('common.inputs.email.placeholder')}
                    iconLeft={<TbInbox />}
                  />
                </InputWrapper>
                <InputWrapper>
                  <InputLabel required>{translate('common.inputs.hasADog')}</InputLabel>
                  <InputRadioField<boolean>
                    name="hasADog"
                    variant="blue"
                    grow
                    options={yesNoOptions}
                    hasError={!!errors.hasADog}
                  />
                </InputWrapper>
                <InputWrapper>
                  <InputCheckboxField name="marketingEmailConsent">
                    <Styled.TermsContainer
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: translate('common.inputs.termsPolicyEmailMarketing.label').replace(
                          '$link',
                          routeLocationDescriptor('privacy').pathname ?? '',
                        ),
                      }}
                    />
                  </InputCheckboxField>
                </InputWrapper>
                <Styled.FormButton>
                  <InputWrapper>
                    <Button type="submit" color="white" shrink loading={isSubmitting}>
                      {translate('common.buttons.getAlerted')}
                    </Button>
                  </InputWrapper>
                </Styled.FormButton>
              </Styled.FormInputs>
            </Styled.FormContent>
          </Form>
        </Styled.FormContainer>
      </Styled.ContentContainer>
    </Styled.Container>
  );
};
